import RestApiModel from "@/api/Model/RestApiModel";

class WorkInProgress extends RestApiModel {
  static getResourceEndpoint() {
    return '/PolicyPending';
  }
}

export default WorkInProgress;
